module.exports = __webpack_public_path__ + "img/DA5788_DE94BD_E078A3_DD83B4-256px.4686ff7e.png";